import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export const AdminMusicTab = ({
  musicFormRef,
  musicTitle,
  setMusicTitle,
  selectedMusicFile,
  setSelectedMusicFile,
  uploadingMusic,
  uploadBackgroundMusic,
  backgroundMusic,
  deleteBackgroundMusic,
  pageAssignments,
  updatePageAssignment,
  modules,
  moduleAssignments,
  updateModuleAssignment
}) => {
  return (
    <>
          <Card ref={musicFormRef}>
            <CardHeader>
              <CardTitle className="text-white">Upload Background Music</CardTitle>
              <p className="text-sm" style={{ color: '#000000' }}>Upload music files to play in the background</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <Label>Music Title</Label>
                <Input
                  value={musicTitle}
                  onChange={(e) => setMusicTitle(e.target.value)}
                  placeholder="Enter music title"
                />
              </div>
              <div>
                <Label>Audio File (MP3, WAV, M4A, AAC, OGG)</Label>
                <Input
                  type="file"
                  accept=".mp3,.wav,.m4a,.aac,.ogg"
                  onChange={(e) => setSelectedMusicFile(e.target.files[0])}
                  disabled={uploadingMusic}
                />
                {selectedMusicFile && (
                  <p className="text-sm text-gray-400 mt-2">
                    Selected: {selectedMusicFile.name}
                  </p>
                )}
              </div>
              <Button
                onClick={uploadBackgroundMusic}
                disabled={uploadingMusic || !musicTitle || !selectedMusicFile}
                className="w-full"
              >
                {uploadingMusic ? 'Uploading...' : 'Upload Music'}
              </Button>
            </CardContent>
          </Card>

          {/* Uploaded Music List */}
          <Card>
            <CardHeader>
              <CardTitle className="text-white">Uploaded Music Files</CardTitle>
            </CardHeader>
            <CardContent>
              {backgroundMusic.length === 0 ? (
                <p className="text-gray-400 text-sm">No music files uploaded yet</p>
              ) : (
                <div className="space-y-2">
                  {backgroundMusic.map((music) => (
                    <div key={music.id} className="flex items-center justify-between p-3 border border-gray-700 rounded">
                      <div className="flex-1">
                        <p className="font-medium text-white">{music.title}</p>
                        <p className="text-xs text-gray-400">{music.filename}</p>
                      </div>
                      <Button
                        size="sm"
                        variant="destructive"
                        onClick={() => deleteBackgroundMusic(music.id)}
                      >
                        Delete
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>

          {/* Page Assignments */}
          <Card>
            <CardHeader>
              <CardTitle className="text-white">Assign Music to Pages</CardTitle>
              <p className="text-sm text-gray-300">Set background music for different pages</p>
            </CardHeader>
            <CardContent>
              {backgroundMusic.length === 0 ? (
                <p className="text-gray-400 text-sm">Please upload music files first</p>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {['home', 'modules', 'forum', 'calendar', 'resources', 'settings', 'messages', 'workshops', 'special-access', 'marketplace', 'bookings', 'live-stream', 'practitioner-hub'].map((pageName) => {
                    const pageLabels = {
                      'special-access': 'Special Access',
                      'live-stream': 'Live Stream',
                      'practitioner-hub': 'Practitioner Hub'
                    };
                    return (
                    <div key={pageName} className="space-y-2 p-4 border-2 border-cyan-500/30 rounded-lg bg-gray-900/50">
                      <div className="mb-2 px-2 py-1 bg-cyan-600 rounded inline-block">
                        <span className="capitalize text-white font-bold text-sm">
                          {pageLabels[pageName] || pageName}
                        </span>
                      </div>
                      <select
                        className="w-full p-2 border-2 border-gray-600 rounded bg-gray-800 text-white font-medium"
                        value={pageAssignments[pageName]?.music_id || ''}
                        onChange={(e) => updatePageAssignment(pageName, e.target.value || null)}
                      >
                        <option value="">No Music</option>
                        {backgroundMusic.map((music) => (
                          <option key={music.id} value={music.id}>
                            {music.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    );
                  })}
                </div>
              )}
            </CardContent>
          </Card>
    </>
  );
};

export default AdminMusicTab;
